import { Component } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationStart, Router } from '@angular/router';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
    public pending: boolean = false;

    constructor(
        public ref: DynamicDialogRef,
        private router: Router,
        public config: DynamicDialogConfig,
    ) {
        this.subscribeToRouterEvents();
    }

    public onCancel(): void {
        this.ref.close(false);
    }

    private subscribeToRouterEvents(): void {
        this.router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe(() => {
            this.ref.close();
        });
    }

    public onSave(): void {
        this.ref.close(true);
    }
}
